import { useAppTheme, useSettings } from '@capsicum/common';
import { removeFirstHash, useOnRamperQuery } from '@capsicum/features/topup/shared';
import { useMemo, useRef } from 'react';

export const useThirdPartyTopUp = () => {
	const {
		settings: { isOnRamperDisclaimerEnabled }
	} = useSettings();
	const {
		theme: { colors, name }
	} = useAppTheme();

	// Store the initial theme to prevent changes during the OnRamper session
	const initialThemeRef = useRef<{ colors: typeof colors; name: string } | null>(null);

	if (!initialThemeRef.current) {
		initialThemeRef.current = { colors, name };
	}

	const widgetUrlStylePayload = useMemo(
		() => ({
			borderRadius: '0.66',
			cardColor: removeFirstHash(initialThemeRef?.current?.colors.backgrounds.main.container ?? ''),
			containerColor: removeFirstHash(initialThemeRef?.current?.colors.backgrounds.main.screen ?? ''),
			primaryBtnTextColor: removeFirstHash(
				initialThemeRef?.current?.name === 'dark'
					? initialThemeRef?.current?.colors.text.main.enabled ?? ''
					: initialThemeRef?.current?.colors.text.main.inverse ?? ''
			),
			primaryColor: removeFirstHash(initialThemeRef?.current?.colors.backgrounds.brand.enabled ?? ''),
			primaryTextColor: removeFirstHash(initialThemeRef?.current?.colors.text.main.enabled ?? ''),
			secondaryColor: removeFirstHash(
				initialThemeRef?.current?.name === 'dark'
					? initialThemeRef?.current?.colors.backgrounds.main.screen ?? ''
					: initialThemeRef?.current?.colors.backgrounds.main.container ?? ''
			),
			secondaryTextColor: removeFirstHash(initialThemeRef?.current?.colors.text.main.subtle ?? ''),
			themeName: initialThemeRef?.current?.name ?? 'light',
			wgBorderRadius: '1'
		}),
		[initialThemeRef.current]
	);

	const { data: onRamperWidgetUrl, isLoading: isOnRamperWidgetUrlLoading } = useOnRamperQuery(widgetUrlStylePayload);

	return { isOnRamperDisclaimerEnabled, isOnRamperWidgetUrlLoading, onRamperWidgetUrl };
};
